import Component from './component'
export default Component



// WEBPACK FOOTER //
// ./src/components/GlobalNav/ProfileDropdown/container.js